var exports = {
  "tX": "packageList__ZiGkIv",
  "KG": "packageItem__wID7Sd",
  "p$": "emptyState__1IMWLz",
  "S$": "packageTypeIcon__WAhP-U",
};

module.exports = exports;
